import Constant from '@/common/constant/Constant';
export const getExpressionQueryChatThreadByTicketId = (ticketId) => {
    let expression = {
        IndexName: Constant.GSI.TICKET_ID_AND_CREATED_AT_INDEX,
        KeyConditionExpression: '#ticketId = :ticketId',
        ExpressionAttributeNames: {
            '#ticketId': 'ticketId'
        },
        ExpressionAttributeValues: {
            ':ticketId': {
                S: ticketId
            }
        },
    };
    return expression;
};